export default {
    methods: {
        formatCurrency(value) {
            if (!value) return "0.00";

            const numValue = typeof value === 'string'
                ? parseFloat(value.replace(/,/g, ""))
                : Number(value);

            return numValue.toLocaleString("en", {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            });
        }
    }
};